"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThreadProtocol = void 0; // Thread protocol version

var version = "0.0.1"; // Thread protocol name

var name = "thread";
/**
 * ThreadProtocol describes the default Threads Protocol parameters
 */

exports.ThreadProtocol = {
  /**
   * Name is the protocol slug.
   */
  name: name,

  /**
   * Code is the protocol code.
   */
  code: 406,

  /**
   * Version is the current protocol version.
   */
  version: version,

  /**
   * Protocol is the threads protocol tag.
   */
  protocol: "/".concat(name, "/").concat(version)
};